<template>
  <div>
    <div id="Chart2" style="width: 800px; height: 150px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts2() {
      var myChart2 = this.$echarts.init(document.getElementById("Chart2"));
      //配置图表
      var option2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 20,
          top: 10,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["2017-01", "2018-01", "2019-01", "2020-01", "2021-01", "2022-01"],
          offset: 20,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            formatter: function (value) {
              if (value == "2017-01") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 100,
                align: "right",
              },
              b: {
                width: 100,
                align: "left",
              },
            },
          },
        },
        yAxis: {
          type: "value",
          min:"1700",
          interval:300,
          splitNumber:3
        },
        series: [
          {
            name: "任期收益",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#fcad2a",
            data: [2176,2135,1897,1765,2005,2200],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(252,173,42,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(252,173,42,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "同类回报",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#539cff",
            data: [1782,1789,1888,1772,1698,2000],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "沪深300",
            type: "line",
            smooth: true,
            symbol: "none",
            showSymbol: false,
            color: "#fd4c4c",
            data: [1809,1801,1976,1976,1853,1973],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253,76,76,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(253,76,76,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
        ],
      };
      myChart2.setOption(option2);
    },
  },
  mounted() {
    this.myEcharts2();
  },
};
</script>

<style scoped>
#Chart1{
  margin-bottom: 12px;
}
</style>